
import axios from 'axios';
import { api } from '../../utils/Constants';
import { updateAxiosToken } from './apiService';

export async function getProviders(params) {
  await updateAxiosToken();

  const url = `${api.url}${api.methods.providers}`;
  const response = await axios.get(url, { params: params });

  return response.data;
}

export async function getProvider(providerId) {
  await updateAxiosToken();

  const url = `${api.url}${api.methods.providers}/${providerId}`;

  try {
    const response = await axios.get(url);

    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    } else {
      console.log(error);
      return error
    }

  }
}

export async function getDrivers(providerId, params) {
  await updateAxiosToken();
  const url = `${api.url}${api.methods.providers}/${providerId}/drivers`;
  const response = await axios.get(url, { params: params });

  return response.data;
}

export async function getDriver(driverId) {
  await updateAxiosToken();
  const url = `${api.url}${api.methods.drivers}/${driverId}`;

  try {
    const response = await axios.get(url);

    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      return null;
    }
    console.log(error);
    return error;
  }
}
